export enum PrivateClassesStatus {
  ZERO = '0',
  ONE = '1',
  TWO = '2',
  FOUR = '4',
  EIGHT = '8',
  TEN = '10',
  UNLIMITED = 'Unlimited',
}
